import { render, staticRenderFns } from "./MensagensPainel.vue?vue&type=template&id=b98b3032"
import script from "./MensagensPainel.vue?vue&type=script&lang=js"
export * from "./MensagensPainel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports